import DetailEpisode from './DetailEpisode'

export default DetailEpisode
// eslint-disable-next-line import/export
export * from './DetailEpisode'
